import "./scss/main.scss";

import "flexibility";
import { WOW } from "wowjs";
import "theia-sticky-sidebar";

var wow = new WOW();
wow.init();

(function ($) {
  $.fn.hScroll = function (amount) {
    amount = amount || 120;
    $(this).bind("DOMMouseScroll mousewheel", function (event) {
      var oEvent = event.originalEvent,
        direction = oEvent.detail ? oEvent.detail * -amount : oEvent.wheelDelta,
        position = $(this).scrollLeft();
      position += direction > 0 ? -amount : amount;
      $(this).scrollLeft(position);
      event.preventDefault();
    });
  };
})(jQuery);

(function ($) {
  $(document).ready(function () {
    $(".main-latest-posts-slider").hScroll(40);
    $(".other-editors-page ul").hScroll(40);

    $(".sticky-sidebar").theiaStickySidebar({
      containerSelector: ".simple-category-page-content",
      additionalMarginTop: 90,
    });

    $(".share-section-small").theiaStickySidebar({
      containerSelector: ".share-trail",
      defaultPosition: "absolute",
      additionalMarginTop: 150,
    });

    $(".jump-to-section").theiaStickySidebar({
      containerSelector: ".jump-to-section-trail",
      defaultPosition: "absolute",
      additionalMarginTop: 150,
    });

    $(window).scroll(function () {
      var winTop = $(window).scrollTop();
      if (winTop >= 50) {
        $("body").addClass("sticky-header");
      } else {
        $("body").removeClass("sticky-header");
      }

      if ($(window).width() > 1279) {
        if (winTop >= 200) {
          $(".category-view").addClass("opacity");
        } else {
          $(".category-view").removeClass("opacity");
        }
      }
    });

    $(document).on("click", function (e) {
      let tooltip = $(".info-tooltip .tooltip");
      if ($(e.target).is(".info-tooltip") === false) {
        tooltip.removeClass("visible");
      }
    });

    $(".info-tooltip > a").on("click", function (e) {
      $(this).next().addClass("visible");
      e.stopPropagation();
    });

    $(".close-btn").on("click", function () {
      $(this).parent().hide();
    });

    $(".filter-link").on("click", function () {
      $(".popup-filter").addClass("opened");
      $("body").addClass("body-fixed");
    });

    $(".alphabet-link").on("click", function () {
      $(".popup-alphabet").addClass("opened");
      $("body").addClass("body-fixed");
    });

    $(".popup .alphabet-link").on("click", function () {
      $(".popup-alphabet").removeClass("opened");
      $(".popup-filter").removeClass("opened");
      $("body").removeClass("body-fixed");
    });

    $("header .icon-search").on("click", function (e) {
      e.preventDefault();
      $(".search-popup").addClass("visible");
      $("#search-input").focus();
    });

    $("form.search .icon-search").on("click", function (e) {
      e.preventDefault();

      console.log("clicked 2");
      var e = $.Event("keypress", { which: 13 });
      $("#search-input").trigger(e);

      $("form.search").submit();
    });

    $(".search-popup .icon-close").on("click", function () {
      $(this).closest(".search-popup").removeClass("visible");
    });

    $("#menu-email").on("focus", function () {
      document.body.scrollTop = $(this).offset().top;
    });

    $(".post-header-jump-to .opener").on("click", function () {
      $(this).toggleClass("opened");
      $(this).next().fadeToggle(300);
    });

    $(".post-header-jump-to ul li").on("click", function () {
      $(".post-header-jump-to .opener").removeClass("opened");
      $(".post-header-jump-to ul").fadeOut(300);
    });

    $(".post-header").each(function () {
      if ($(this).children().length === 0) {
        $(this).hide();
      }
    });

    $(document).on("keydown", function (e) {
      if (e.keyCode == 27) $(".search-popup").removeClass("visible");
    });

    if ($(window).width() < 1279) {
      $("header nav li.hover > a").removeAttr("href");
      $("header nav li.hover > a").on("click", function (e) {
        e.preventDefault();
        $(this).toggleClass("active");
        $(".navbar-sidebar").toggleClass("visible");
        $("body").toggleClass("locked");
        ga("send", {
          hitType: "event",
          eventCategory: "Navigation",
          eventAction: "Tap",
          eventLabel: "Menu",
          eventValue: 0,
        });
      });
    }

    if ($(window).width() > 1279) {
      $("header nav li.hover").hover(
        function () {
          $("header").addClass("opened-menu");
          var subMenu = $(this).find(".sub-menu");

          $(subMenu).css("display", "flex").hide().fadeIn(100);
          $(subMenu)
            .find(".latest")
            .children(".articleContainer")
            .css("display", "flex")
            .hide()
            .fadeIn(100);
          $(subMenu)
            .find(".video")
            .children(".articleContainer")
            .css("display", "flex")
            .hide()
            .fadeIn(100);
        },

        function () {
          $("header").removeClass("opened-menu");
          $(".header nav li.hover .sub-menu").fadeOut(100);
        }
      );

      $("header nav li.sub-menu-hover").hover(
        function () {
          $("header").addClass("opened-menu");

          if ($(this).children(".articleContainer").css("display") == "flex")
            return;

          $(this)
            .children(".articleContainer")
            .css("display", "flex")
            .hide()
            .fadeIn(100);
        },

        function () {
          $("header").removeClass("opened-menu");
          $(".header nav li.sub-menu-hover .articleContainer").fadeOut(100);
        }
      );
    }

    function addTextToMenu(options) {
      let elementSelector = options.elementSelector;

      $(window).scroll(function () {
        let element = $(elementSelector);
        element.html($(".post-header-jump-to .mPS2id-highlight").html());
      });
    }

    addTextToMenu({
      elementSelector: ".post-header-jump-to .opener .text",
    });

    function hideOnScrollinit(options) {
      var elementSelector = options.elementSelector || ".single-post header";

      var didScroll;
      var lastScrollTop = 0;
      var delta = 5;

      $(window).scroll(function () {
        didScroll = true;
        var element = $(elementSelector);
        if ($(window).scrollTop() === 0) {
          element.removeClass("scroll");
        } else {
          element.addClass("scroll");
        }
      });

      setInterval(function () {
        if (didScroll) {
          hasScrolled();
          didScroll = false;
        }
      }, 250);

      function hasScrolled() {
        var navbarHeight = $(elementSelector).outerHeight();
        var st = $(window).scrollTop();

        if (Math.abs(lastScrollTop - st) <= delta) {
          return;
        }

        if (st > lastScrollTop && st > navbarHeight) {
          $(elementSelector).css("top", "-4.7rem");
          $(".post-header, .post-header-jump-to").css("top", "0");
        } else {
          $(elementSelector).css("top", "0");
          $(".post-header, .post-header-jump-to").css("top", "4.7rem");
        }

        lastScrollTop = st;
      }
    }

    hideOnScrollinit({
      elementSelector: ".single-post header",
    });

    $(window).trigger("scroll");

    $(".jump-to-section-review button").on("click", function () {
      $(this).parent().toggleClass("opened");
      $(".jump-to-section-review li a").removeClass("active");
    });
    $(window).trigger("scroll");

    $(".jump-to-section-review li a").on("click", function () {
      $(".jump-to-section-review li a").removeClass("active");
      $(this).addClass("active");
    });

    $(".read-next-from-category-section a").on("click", function () {
      ga("send", {
        hitType: "event",
        eventCategory: "Read More",
        eventAction: "Link Click",
        eventLabel: "Read This Next",
        eventValue: 5,
      });
    });

    $(".latest-posts-section a").on("click", function () {
      ga("send", {
        hitType: "event",
        eventCategory: "Read More",
        eventAction: "Link Click",
        eventLabel: "Latest Posts",
        eventValue: 5,
      });
    });

    $(".shared-counts-wrap .shared-counts-button").on("click", function () {
      ga("send", {
        hitType: "event",
        eventCategory: "Sharing",
        eventAction: "Link Click",
        eventLabel: "Social Shares",
        eventValue: 10,
      });
    });

    $(".popular-reads-list a").on("click", function () {
      ga("send", {
        hitType: "event",
        eventCategory: "Read More",
        eventAction: "Link Click",
        eventLabel: "Desktop Sidebar",
        eventValue: 5,
      });
    });

    $(".read-this-next-tip a").on("click", function () {
      ga("send", {
        hitType: "event",
        eventCategory: "Read More",
        eventAction: "Link Click",
        eventLabel: "In-Article Link",
        eventValue: 5,
      });
    });

    $(".wc_comm_form .wc_comm_submit").on("click", function () {
      ga("send", {
        hitType: "event",
        eventCategory: "Discussion",
        eventAction: "Button Click",
        eventLabel: "Comment",
        eventValue: 10,
      });
    });

    $(".subscribe_form button").on("click", function () {
      ga("send", {
        hitType: "event",
        eventCategory: "Newsletter",
        eventAction: "Button Click",
        eventLabel: "Website",
        eventValue: 100,
      });
    });

    $(".header nav > ul > li.hover+li > a").on("click", function () {
      ga("send", {
        hitType: "event",
        eventCategory: "Navigation",
        eventAction: "Tap",
        eventLabel: "Watch",
        eventValue: 0,
      });
    });

    $(".header nav > ul > li:last-child > a").on("click", function () {
      ga("send", {
        hitType: "event",
        eventCategory: "Navigation",
        eventAction: "Tap",
        eventLabel: "Listen",
        eventValue: 0,
      });
    });

    $(".filter-headline .filter-link").on("click", function () {
      ga("send", {
        hitType: "event",
        eventCategory: "Navigation",
        eventAction: "Tap",
        eventLabel: "District",
        eventValue: 0,
      });
    });

    $(".filter-headline .alphabet-link").on("click", function () {
      ga("send", {
        hitType: "event",
        eventCategory: "Navigation",
        eventAction: "Tap",
        eventLabel: "A-Z",
        eventValue: 0,
      });
    });
  });
})(jQuery);
